import { render } from "./ToggleableText.vue?vue&type=template&id=30f1eee3"
import script from "./ToggleableText.vue?vue&type=script&lang=js"
export * from "./ToggleableText.vue?vue&type=script&lang=js"

import "./ToggleableText.vue?vue&type=style&index=0&id=30f1eee3&lang=scss"

import exportComponent from "/var/www/basic/vue-about-us/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__